// extracted by mini-css-extract-plugin
export var chevronIcon = "_b0-2";
export var teamName = "_b0-1";
export var teamSwitcherButton = "_b0-0";